import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "flex-row-box video-controller-wrap",
  style: {
    "justify-content": "center",
    "align-items": "flex-start",
    "width": "100%"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "flex-row-box side-box",
  style: {
    "justify-content": "flex-start",
    "opacity": "0"
  }
};
const _hoisted_3 = {
  key: 1,
  class: "flex-row-box side-box",
  style: {
    "justify-content": "flex-start",
    "opacity": "1"
  }
};
const _hoisted_4 = {
  class: "flex-row-box video-controls",
  style: {
    "margin-top": "20px",
    "width": "200px",
    "justify-content": "center"
  }
};
const _hoisted_5 = {
  class: "timer"
};
import { ref, computed, watch, onBeforeUnmount } from 'vue';
import { useVideoStore } from '@/pinia';
import { emitter } from '@/utils/events';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { useRoute } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'controller',
  props: {
    digitalMan: {
      type: Object,
      default: () => ({})
    },
    multilingual: {
      type: Object,
      default: () => ({})
    },
    duration: {
      type: Number,
      default: 0
    },
    mediaUrl: {
      type: String,
      default: ''
    },
    audioText: {
      type: Array,
      default: () => []
    },
    clearFlag: {
      type: Boolean,
      default: false
    },
    showSubtitles: {
      type: Boolean,
      default: true
    },
    screen: {
      type: String,
      default: '横屏'
    }
  },
  emits: ['togglePlay', 'update:showSubtitles', 'update:screen', 'sourceChange'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const route = useRoute();
    const aspectRatio = ref('1920x1080');
    const videoStore = useVideoStore();
    let vModelShowSubtitles = computed({
      get() {
        return props.showSubtitles;
      },
      set(value) {
        emits('update:showSubtitles', value);
      }
    });
    let vModelScreen = computed({
      get() {
        return props.screen;
      },
      set(value) {
        emits('update:screen', value);
      }
    });
    let screenOption = [{
      label: '横屏',
      value: '横屏'
    }, {
      label: '竖屏',
      value: '竖屏'
    }];
    const aspectRatioOptions = [{
      label: '16:9',
      value: '1920x1080'
    }, {
      label: '9:16',
      value: '1080x1920'
    }, {
      label: '9:16',
      value: '720x1280'
    }, {
      label: '16:9',
      value: '1280x720'
    }];
    const formatSecondsToTime = seconds => {
      let milliseconds = seconds * 1000; // 转换为毫秒
      let hours = Math.floor(milliseconds / (1000 * 60 * 60));
      let minutes = Math.floor(milliseconds % (1000 * 60 * 60) / (1000 * 60));
      let remainingSeconds = Math.floor(milliseconds % (1000 * 60) / 1000);
      let millisecondsRemainder = milliseconds % 1000;
      // 确保小时、分钟、秒和毫秒始终显示两位数（对于小时，可能需要显示一位或两位）
      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      remainingSeconds = String(remainingSeconds).padStart(2, '0');
      millisecondsRemainder = String(millisecondsRemainder).substring(0, 3).padStart(3, '0');
      return `${hours}:${minutes}:${remainingSeconds}.${millisecondsRemainder}`;
    };
    const playedDuration = ref('00:00:00.000');
    const totalDuration = ref('00:00:00.000');
    const endTimestamp = ref(0);
    const playing = ref(false);
    const audio = ref(new Audio());
    let loadingId = "";
    audio.value.addEventListener("loadstart", () => {
      if (loadingId) videoStore.removeSourceLoading(loadingId);
      loadingId = videoStore.addSourceLoading();
    });
    audio.value.addEventListener("loadeddata", () => {
      videoStore.removeSourceLoading(loadingId);
      loadingId = "";
    });
    const playVideo = async flag => {
      if (videoStore.sourceLoading) return;
      if (flag && !props.duration) {
        return ElMessage.warning('请先在右侧生成音频内容并保存');
      }
      if (playing.value) emits('togglePlay', flag);
      playing.value = flag;
      if (!flag) {
        audio.value.pause();
        audio.value.currentTime = 0;
        return;
      }
      ElMessage.warning('预览数字人 - 暂不支持口型对齐预览，合成后可查看完整动态效果');
      // duration也需要改变为音频时间，需要播放音频，监听音频时间，改变播放时长
      const preloadUrl = await fetch(props.mediaUrl).then(response => response.blob()).then(blob => URL.createObjectURL(blob));
      audio.value.src = preloadUrl;
      audio.value.play();
      audio.value.addEventListener('ended', () => {
        console.log('播放完毕');
        playing.value = false;
        emits('togglePlay', false);
      });
      audio.value.addEventListener('playing', () => {
        console.log('开始播放');
        emits('togglePlay', true);
      });
      // 监听播放进度实时变化（例如每秒更新一次）
      audio.value.addEventListener('timeupdate', () => {
        // console.log(audio.value.currentTime);
        if (audio.value.currentTime > endTimestamp.value) {
          playedDuration.value = formatSecondsToTime(endTimestamp.value);
        } else {
          playedDuration.value = formatSecondsToTime(audio.value.currentTime);
        }
      });
    };
    watch(() => props.duration, (newVal, oldVal) => {
      if (newVal) {
        totalDuration.value = formatSecondsToTime(props.duration);
        videoStore.videoDuration = props.duration;
      }
    }, {
      immediate: true
    });
    watch(() => props.audioText, (newVal, oldVal) => {
      if (newVal && newVal.length) {
        const lastSentence = newVal[newVal.length - 1];
        const lastIdx = lastSentence.words.length - 1;
        endTimestamp.value = lastSentence.words[lastIdx].endTimestamp / 10000 / 1000;
        totalDuration.value = formatSecondsToTime(endTimestamp.value);
        videoStore.videoDuration = endTimestamp.value;
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.clearFlag, newVal => {
      if (newVal) {}
    });
    watch(() => props.digitalMan, newVal => {
      if (newVal.resolution) {
        aspectRatio.value = newVal.resolution;
      }
    });
    watch(() => props.mediaUrl, newVal => {
      if (newVal) {
        audio.value.src = newVal;
      }
    });
    watch(() => vModelScreen.value, newVal => {
      if (newVal) {
        videoStore.sreen = newVal;
      }
    }, {
      immediate: true
    });
    let changeScreenFn = value => {
      // let { navsType = '' } = route.query
      // 删除数字人
      // if (navsType === 'aiClip') emits('sourceChange', 24);
      emitter.emit('changeScreenFn', value);
    };
    onBeforeUnmount(() => {
      playVideo(false);
    });
    // watch(()=>props.digitalMan, (newVal, oldVal) => {
    //   if(newVal) {}
    // },{
    //   immediate: true,
    //   deep: true
    // })
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_switch = _resolveComponent("el-switch");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [false ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[4] || (_cache[4] = _createTextVNode(" 画面比例 ")), _createVNode(_component_el_select, {
        modelValue: aspectRatio.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => aspectRatio.value = $event),
        placeholder: "Select",
        style: {
          "width": "60px",
          "margin-left": "10px"
        },
        "suffix-icon": ""
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(aspectRatioOptions, item => {
          return _createVNode(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), true ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[5] || (_cache[5] = _createTextVNode(" 输出类型 ")), _createVNode(_component_el_select, {
        modelValue: _unref(vModelScreen),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(vModelScreen) ? vModelScreen.value = $event : vModelScreen = $event),
        onChange: _unref(changeScreenFn),
        placeholder: "屏幕",
        style: {
          "width": "60px",
          "margin-left": "10px"
        },
        "suffix-icon": ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(screenOption), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("a", {
        class: "play-btn",
        onClick: _cache[2] || (_cache[2] = $event => playVideo(!playing.value))
      }, [_createVNode(_component_svgIcon, {
        iconClass: playing.value ? 'puse' : 'playvideo',
        width: "2.0833vw",
        height: "2.0833vw",
        style: {
          "padding-right": "1px"
        }
      }, null, 8, ["iconClass"])])), [[_directive_loading, _unref(videoStore).sourceLoading]])]), _createElementVNode("div", {
        class: "flex-row-box text-show side-box",
        style: _normalizeStyle({
          'justify-content': 'flex-end',
          'opacity': !__props.multilingual.ttsType ? 1 : 0
        })
      }, [_cache[6] || (_cache[6] = _createTextVNode(" 字幕 ")), _createVNode(_component_el_switch, {
        modelValue: _unref(vModelShowSubtitles),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(vModelShowSubtitles) ? vModelShowSubtitles.value = $event : vModelShowSubtitles = $event),
        "active-color": "#6668FFCC",
        "inactive-color": "#f1f1f1",
        size: "mini",
        style: {
          "margin-left": "10px"
        }
      }, null, 8, ["modelValue"])], 4), _createElementVNode("p", _hoisted_5, _toDisplayString(playedDuration.value) + " / " + _toDisplayString(totalDuration.value), 1)]);
    };
  }
});